<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog modal-lg" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4  class="modal-title">Configuración vista documentos</h4>
				</div>
				<div class="modal-body">
					<loading :active="loading">
						<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
					</loading>
					<template v-if="settings">
						<template v-if="settings.length">
							<div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
								<template v-for="setting in settings">
									<div class="panel panel-default">
										<div class="panel-heading" role="tab">
											<h4 class="panel-title">
												<a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" :href="'#collapse-setting-' + setting.id" :aria-controls="'collapse-setting-' + setting.id">
													{{ $t("settings.docs." + setting.doc) }}
												</a>
											</h4>
										</div>
										<div :id="'collapse-setting-' + setting.id" class="panel-collapse collapse" role="tabpanel">
											<div class="panel-body p-0">
												<div class="row">
													<div class="col-md-12">
														<table class="table table-hover table-striped table-condensed">
															<tbody>
																<template v-if="setting.doc == 'budget-pdf'">
																	<tr :id="'setting-' + setting.id + '-content_columns'">
																		<td>Columnas</td>
																		<td>
																			<select @change="update(setting, 'content_columns', {content_columns:setting.content_columns})" v-model="setting.content_columns" class="form-control pull-right">
																				<option value="1">1</option>
																				<option value="2">2</option>
																			</select>
																		</td>
																	</tr>
																</template>
																<template v-if="setting.doc == 'budget-pdf'">
																	<tr :id="'setting-' + setting.id + '-display_logo'">
																		<td>Mostrar logo</td>
																		<td>
																			<div class="pull-right">
																				<input @change="update(setting, 'display_logo', {display_logo:setting.display_logo})" type="checkbox" v-model="setting.display_logo" class="js-switch pull-right" data-size="small">
																			</div>
																		</td>
																	</tr>
																</template>
																<tr :id="'setting-' + setting.id + '-reference'">
																	<td>ID</td>
																	<td>
																		<div class="pull-right">
																			<input @change="update(setting, 'id_field', {id_field:setting.id_field})" type="checkbox" v-model="setting.id_field" class="js-switch pull-right" data-size="small">
																		</div>
																	</td>
																</tr>
																<tr :id="'setting-' + setting.id + '-reference'">
																	<td>Referencia</td>
																	<td>
																		<div class="pull-right">
																			<input @change="update(setting, 'reference', {reference:setting.reference})" type="checkbox" v-model="setting.reference" class="js-switch pull-right" data-size="small">
																		</div>
																	</td>
																</tr>
																<tr :id="'setting-' + setting.id + '-title'">
																	<td>Títitulo</td>
																	<td>
																		<div class="pull-right">
																			<input @change="update(setting, 'title', {title:setting.title})" type="checkbox" v-model="setting.title" class="js-switch pull-right" data-size="small">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>Descripción</td>
																	<td>
																		<div class="pull-right">
																			<input @change="update(setting, 'description', {description:setting.description})" type="checkbox" v-model="setting.description" class="js-switch pull-right" data-size="small">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>Atributos</td>
																	<td>
																		<div class="pull-right">
																			<input @change="update(setting, 'attributes', {attributes:setting.attributes})" type="checkbox" v-model="setting.attributes" class="js-switch pull-right" data-size="small">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>Precio base</td>
																	<td>
																		<div class="pull-right">
																			<input @change="update(setting, 'base_price', {base_price:setting.base_price})" type="checkbox" v-model="setting.base_price" class="js-switch pull-right" data-size="small">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>Descuento</td>
																	<td>
																		<div class="pull-right">
																			<input @change="update(setting, 'discount', {discount:setting.discount})" type="checkbox" v-model="setting.discount" class="js-switch pull-right" data-size="small">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>Ahorro</td>
																	<td>
																		<div class="pull-right">
																			<input @change="update(setting, 'save', {save:setting.save})" type="checkbox" v-model="setting.save" class="js-switch pull-right" data-size="small">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>Precio</td>
																	<td>
																		<div class="pull-right">
																			<input @change="update(setting, 'price', {price:setting.price})" type="checkbox" v-model="setting.price" class="js-switch pull-right" data-size="small">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>Impuestos</td>
																	<td>
																		<div class="pull-right">
																			<input @change="update(setting, 'taxes', {taxes:setting.taxes})" type="checkbox" v-model="setting.taxes" class="js-switch pull-right" data-size="small">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>Importe</td>
																	<td>
																		<div class="pull-right">
																			<input @change="update(setting, 'amount', {amount:setting.amount})" type="checkbox" v-model="setting.amount" class="js-switch pull-right" data-size="small">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>Unidad de medida</td>
																	<td>
																		<div class="pull-right">
																			<input @change="update(setting, 'total_measurement_unit', {total_measurement_unit:setting.total_measurement_unit})" type="checkbox" v-model="setting.total_measurement_unit" class="js-switch pull-right" data-size="small">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>Extras</td>
																	<td>
																		<div class="pull-right">
																			<input @change="update(setting, 'extras', {extras:setting.extras})" type="checkbox" v-model="setting.extras" class="js-switch pull-right" data-size="small">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>Total</td>
																	<td>
																		<div class="pull-right">
																			<input @change="update(setting, 'total', {total:setting.total})" type="checkbox" v-model="setting.total" class="js-switch pull-right" data-size="small">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>Cantidad</td>
																	<td>
																		<div class="pull-right">
																			<input @change="update(setting, 'quantity', {quantity:setting.quantity})" type="checkbox" v-model="setting.quantity" class="js-switch pull-right" data-size="small">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>Total unidad de medida</td>
																	<td>
																		<div class="pull-right">
																			<input @change="update(setting, 'total_measurement_unit_quantity', {total_measurement_unit_quantity:setting.total_measurement_unit_quantity})" type="checkbox" v-model="setting.total_measurement_unit_quantity" class="js-switch pull-right" data-size="small">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>Total impuestos</td>
																	<td>
																		<div class="pull-right">
																			<input @change="update(setting, 'total_taxes', {total_taxes:setting.total_taxes})" type="checkbox" v-model="setting.total_taxes" class="js-switch pull-right" data-size="small">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>Total por cantidad</td>
																	<td>
																		<div class="pull-right">
																			<input @change="update(setting, 'total_price_quantity', {total_price_quantity:setting.total_price_quantity})" type="checkbox" v-model="setting.total_price_quantity" class="js-switch pull-right" data-size="small">
																		</div>
																	</td>
																</tr>
															</tbody>
														</table>
													</div>
												</div>
											</div>
										</div>
									</div>
								</template>
							</div>
						</template>
					</template>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import VueElementLoading from 'vue-element-loading'
	export default {
		props: ['user', 'isAuth'],
		components: {
			'loading': VueElementLoading,
		},
		data () {
			return {
				modal: {
					selector: 'modal-setting-docs'
				},
				loading: false,
				settings: null,
			}
		},
		methods: {
			open() {
				this.init()
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			init() {
				this.getData()
			},
			getData() {
				this.loading = true
				this.settings = null
				this.$http.get('admin/settings/docs')
				.then(response => {
					this.settings = response.body
					this.loading = false
					this.loadSwitchs()
				})
			},
			loadSwitchs() {
				this.$nextTick( () => {
					$('.js-switch').each(function() {
						new Switchery($(this)[0], $(this).data());
					})
				})
			},
			update(setting, column, data) {
				var tr = $('#setting-' + setting.id + '-' + column)
				tr.addClass('disabled')
				this.$http.put('admin/settings/docs/' + setting.id, data)
				.then(response => {
					tr.removeClass('disabled')
				})
				.catch(response => {
					console.log(response)
					tr.removeClass('disabled')
				})
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/settings/views/Docs.vue